import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/list-title.module.css';

interface ListTitleProps extends TypographyProps {
    colored?: boolean;
    brand?: string | null;
}

const ListTitle = ({ colored, brand, tag = 'h4', className = null, ...props }: ListTitleProps) => {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [styles.colored]: colored,
                },
                className,
            ])}
            data-brand={brand}
            {...props}
        />
    );
};

export default ListTitle;
